import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SalesReportaContent from '../SalesReportaContent';
import { setFromDate, setToDate, setSelectedBranch, fetchSalesReportaData } from '../../../store/slices/salesReportaSlice';

const SalesReporta = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';
    const storedBranchName = localStorage.getItem('branchname') || 'Current Branch';

    useEffect(() => {
        const today = new Date();
        dispatch(setFromDate(today));
        dispatch(setToDate(today));
        dispatch(setSelectedBranch({ branch_id: storedBranchId, branch_name: storedBranchName }));
        dispatch(
            fetchSalesReportaData({
                fromDate: today,
                toDate: today,
                branchId: storedBranchId
            })
        );
    }, [dispatch, storedBranchId, storedBranchName]);

    return <SalesReportaContent isManagerView />;
};

export default SalesReporta;
